import axios from "axios";
import config from "@/router/globalConfig";

export default {
    SaveNominee(_SaveData) {
        return axios.post(config.WEB_API_PATH + 'NomineeDetails/v1/SetOnLinePOCondidate', _SaveData, {
            headers: { __RequestVerificationToken: config.AF_Token, Authorization: config.LOG_Token }
        });
    },
    GetNominee(_param) {
        return axios.post(config.WEB_API_PATH + 'NomineeDetails/v1/GetOnLinePOCondidate', _param, {
            headers: { __RequestVerificationToken: config.AF_Token, Authorization: config.LOG_Token }
        });
    },
    GetNomineeMaster(_param) {
        return axios.post(config.WEB_API_PATH + 'NomineeDetails/v1/GetOnLinePOCondidateMaster', _param, {
            headers: { __RequestVerificationToken: config.AF_Token, Authorization: config.LOG_Token }
        });
    },
    GetMasterAccountList(_data_) {
        return axios.get(config.WEB_API_PATH + 'NomineeDetails/v1/GetMasterNominee', {
            headers: { __RequestVerificationToken: config.AF_Token, Authorization: config.LOG_Token },
            params: _data_
        });
    },
    SaveMasterData(_param) {
        return axios.post(config.WEB_API_PATH + 'NomineeDetails/v1/SaveCandidateMaster', _param, {
            headers: { __RequestVerificationToken: config.AF_Token, Authorization: config.LOG_Token }
        });
    },
    GetMemberType(_data) {
        return axios.get(config.WEB_API_PATH + 'NomineeDetails/v1/GetMemberType', {
            headers: { __RequestVerificationToken: config.AF_Token, Authorization: config.LOG_Token },
            params: _data
        });
    },
    GetMemebrBank(_data) {
        return axios.get(config.WEB_API_PATH + 'NomineeDetails/v1/GetMemberBank', {
            headers: { __RequestVerificationToken: config.AF_Token, Authorization: config.LOG_Token },
            params: _data
        });
    },
    GetSampleExcel(_data) {
        return axios.get(config.WEB_API_PATH + 'JsonFormat/v1/GetSampleExcel', {
            headers: { __RequestVerificationToken: config.AF_Token, Authorization: config.LOG_Token },
            params: _data
        });
    },
    ImportPOCandidatesFromExcel(_data) {
        return axios.post(config.WEB_API_PATH + 'JsonFormat/v1/ImportPOCandidatesFromExcel', _data, {
            headers: { __RequestVerificationToken: config.AF_Token, Authorization: config.LOG_Token }
        });
    },
    ImportUpdatedPOCandidatesFromExcel(_data) {
        return axios.post(config.WEB_API_PATH + 'JsonFormat/v1/ImportUpdatedPOCandidatesFromExcel', _data, {
            headers: { __RequestVerificationToken: config.AF_Token, Authorization: config.LOG_Token }
        });
    },
    GetFoodPreference(_data) {
        return axios.get(config.WEB_API_PATH + 'NomineeDetails/v1/GetFoodPreference', {
            headers: { __RequestVerificationToken: config.AF_Token, Authorization: config.LOG_Token },
            params: _data
        });
    },
}


// WEBPACK FOOTER //
// ./src/components/serviceJS/NomineeDetails.js